/**
 * zeluslugi.ru
 * Accordion
 * @author      delphinpro <delphinpro@gmail.com>
 * @license     licensed under the MIT license
 *
 * @external jQuery
 */

(function ($) {
    $('.accordion').each(function () {
        let $accordion = $(this);
        let $toggler   = $('.accordion__toggler', $accordion);
        let $panel     = $('.accordion__content', $accordion);

        $toggler.on('click', function () {
            $accordion.toggleClass('accordion_open');
            $panel.slideToggle($accordion.hasClass('accordion_open'));
        });

        $panel.hide();
    });

    $('[data-accordion]').each(function () {
        let $toggler   = $(this);
        let $panel     = $($(this).data('accordion'));

        $toggler.on('click', function () {
            $panel.slideToggle();
        });

        // $panel.hide();
    });


})(jQuery);
